import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from '../styles';
import { SwitcherNavItem } from '../types';

const StyledSwitcherItem = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
  padding: 16px 25px;
  margin: 0 2px;

  display: flex;
  align-items: center;
  text-align: center;
  position: relative;

  color: ${COLORS.neutral_600};
  text-decoration: none;

  svg {
    margin-right: 16px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 4px;
    top: 4px;
    bottom: 4px;
    width: 4px;
    background-color: transparent;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  &.active:not(.disabled) {
    font-weight: bold;
    color: ${COLORS.neutral_800};
    &:after {
      background-color: ${COLORS.primary_500};
    }

    svg path {
      fill: ${COLORS.neutral_800};
    }
  }

  &.disabled {
    color: ${COLORS.neutral_300};
    background-color: ${COLORS.neutral_100};
  }

  &:hover:not(.disabled) {
    color: ${COLORS.primary_600};
    background-color: ${COLORS.primary_20};

    svg path {
      fill: ${COLORS.primary_600};
    }
  }

  &:active:not(.disabled) {
    color: ${COLORS.primary_800};
    background-color: ${COLORS.primary_100};
    box-shadow: none;
    &:after {
      background-color: ${COLORS.primary_500};
    }
    svg path {
      fill: ${COLORS.primary_800};
    }
  }

  &:focus:not(.disabled) {
    box-shadow: 0px 0px 8px ${COLORS.primary_500}, 0px 4px 12px rgba(46, 127, 161, 0.25);
    outline: none;
  }
`;

const A = styled.a``;

const SwitcherMenuItem = ({ label, url, disabled, Icon, as = A, testId }: SwitcherNavItem) => (
  <StyledSwitcherItem
    onClick={() => (window.location.href = url || '')}
    as={as}
    href={url || ''}
    target="_parent"
    key={label}
    className={disabled ? 'disabled' : ''}
    data-testid={testId}>
    {Icon && <Icon size="22px" color="#666666" />}
    {label}
  </StyledSwitcherItem>
);

export default SwitcherMenuItem;
